import { ConfigService } from '../../../infra/config'
import { BaseRepository } from '../../../infra/base.repository'
import type { PartnerEntry } from './partner-entry.entity'

export class PartnersEntriesRepository extends BaseRepository<PartnerEntry> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.toolsApiUrl + '/' + 'partners/entries', token, cache)
    }

    async getTotals(partnerId: string) {
        if (!partnerId) partnerId = ''
        const url = this.config.toolsApiUrl + '/partners/entries/totals?partnerId=' + partnerId + '&token=' + this.resolvedToken
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
